<script>
import * as m from '@app/paraglide/messages.js';
function exit() {
    const ipcRenderer = window.ipcRenderer; 
    ipcRenderer.invoke('quit');
}
</script>
<a class="dropdown-item" 
   href="#!/" 
   id="exitMenuItem"
   role="menuitem"
   aria-label={m.exit_application()}
   onclick={exit}>{m.exit()}</a>